import { ElementSceneInfo } from '../types/element.types';
import { ElementInfo } from '../types/element.types';

/**
 * 组装场次元素关系数据
 * 将 elementRelations（只包含关系字段）和 elements（完整的场次元素数据）组装成完整的关系数据
 * 
 * @param relations 场次元素关系列表（只包含关系字段）
 * @param elements 场次元素列表（完整数据）
 * @returns 组装后的关系数据列表
 */
export const enrichElementRelations = (
  relations: ElementSceneInfo[],
  elements: ElementInfo[]
): ElementSceneInfo[] => {
  if (!relations || relations.length === 0) {
    return [];
  }
  
  if (!elements || elements.length === 0) {
    return relations;
  }

  // 创建 elementID -> element 的映射
  const elementMap = new Map<string, ElementInfo>();
  elements.forEach(item => {
    if (item.elementID) {
      elementMap.set(item.elementID, item);
    }
  });

  // 组装数据：关系字段 + element 字段
  return relations.map(rel => {
    const element = elementMap.get(rel.elementID);
    if (!element) {
      // 如果找不到对应的 element，返回原始关系数据
      return rel;
    }

    return {
      ...rel,
      // 从 element 获取完整字段
      elementType: element.elementType,
      elementName: element.elementName,
      elementAbbr: element.elementAbbr,
      elementNO: element.elementNO,
      // 保留关系字段（这些字段优先使用关系表中的值）
      elementQtyInScene: rel.elementQtyInScene,
      elementBelongBreakdownID: rel.elementBelongBreakdownID || element.elementBelongBreakdownID,
    };
  });
};








